module.exports = __webpack_public_path__ + "img/event2412_3_2.8d467c84.jpg";